// Canvas-related constants shared between DesignerCanvas and ElementRenderer
// These values control element positioning constraints within the canvas

export const EDGE_OFFSET_BOTTOM = 1.5;
export const EDGE_OFFSET_RIGHT = 2.5;

export const HEADER_CONTROLS_HEIGHT = 74;
